<ng-container *ngIf="!!dynamicContent && dynamicContent?.lang === lang">
  <mat-card appearance="outlined" class="person-form">
    <ibex-checkbox *ngIf="!!parent?.config.showShowInWidgetCheckbox" [checked]="dynamicContent.content.showInWidget" [title]="'dynamicContent.openHours.showInWidget' | translate" (click)="dynamicContent.content.showInWidget = $event.val"></ibex-checkbox>
    <ibex-checkbox *ngIf="!create" [checked]="hideEmptyFields" [title]="'dynamicContent.hideEmptyFields' | translate" (click)="hideEmptyFields = $event.val; switchHideEmptyFields()"></ibex-checkbox>
    <ibex-checkbox *ngIf="create && showToggle" [checked]="hideEmptyFields" [title]="'dynamicContent.showAllFields' | translate" (click)="hideEmptyFields = $event.val; switchShowAllFields()"></ibex-checkbox>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['salutation']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.salutation' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.salutation" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'dynamicContent.lastname' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.lastname" matInput required>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'dynamicContent.firstname' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.firstname" matInput required>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['department']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.department' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.department" matInput>
    </mat-form-field>
    <ng-container *ngIf="(hideEmptyFields && showFields['house']) || !hideEmptyFields">
      <mat-form-field *ngIf="orientation; else defaultHouse">
        <mat-label>{{'dynamicContent.house' | translate}}</mat-label>
        <mat-select [(ngModel)]="dynamicContent.content.house">
          <mat-option *ngFor="let house of houses" [value]="house.code">{{ house.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <ng-template #defaultHouse>
        <mat-form-field>
          <mat-label>{{'dynamicContent.house' | translate}}</mat-label>
          <input [(ngModel)]="dynamicContent.content.house" matInput>
        </mat-form-field>
      </ng-template>
    </ng-container>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['floor']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.floor' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.floor" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['room']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.room' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.room" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['job']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.job' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.job" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['phone']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.phone' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.phone" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['email']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.email' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.email" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['order']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.order' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.order" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['birthday']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.birthday' | translate}}</mat-label>
      <input (change)="checkDate($event)" (dateChange)="checkDate($event)" [matDatepicker]="startPicker" [max]="dynamicContent.content.birthday" [value]="dynamicContent.content.birthday" matInput>
      <mat-datepicker-toggle [for]="startPicker" matPrefix></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field *ngIf="categories?.length && ((hideEmptyFields && showFields['categories']) || !hideEmptyFields)">
      <mat-label>{{'dynamicContent.categories' | translate}}</mat-label>
      <mat-select [(ngModel)]="dynamicContent.content.categories" multiple>
        <mat-option *ngFor="let category of categories" [value]="category._id">{{ category.title }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['note']) || !hideEmptyFields" class="full-width">
      <mat-label>Text</mat-label>
      <textarea [(ngModel)]="dynamicContent.content.note" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10"></textarea>
    </mat-form-field>
  </mat-card>
</ng-container>

<ng-container *ngIf="translationEntries?.[lang] && dynamicContent?.lang !== lang">
  <mat-card appearance="outlined" class="person-form">
    <ibex-checkbox *ngIf="!!parent?.config.showShowInWidgetCheckbox" [checked]="dynamicContent.content.showInWidget" [title]="'dynamicContent.openHours.showInWidget' | translate" (click)="dynamicContent.content.showInWidget = $event.val"></ibex-checkbox>
    <ibex-checkbox *ngIf="!create" [checked]="hideEmptyFields" [title]="'dynamicContent.hideEmptyFields' | translate" (click)="hideEmptyFields = $event.val; switchHideEmptyFields()"></ibex-checkbox>
    <ibex-checkbox *ngIf="create && showToggle" [checked]="hideEmptyFields" [title]="'dynamicContent.showAllFields' | translate" (click)="hideEmptyFields = $event.val; switchShowAllFields()"></ibex-checkbox>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['salutation']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.salutation' | translate}}</mat-label>
      <input [(ngModel)]="translationEntries[lang].content.salutation" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['department']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.department' | translate}}</mat-label>
      <input [(ngModel)]="translationEntries[lang].content.department" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="((hideEmptyFields && showFields['house']) || !hideEmptyFields) && !orientation">
      <mat-label>{{'dynamicContent.house' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.house" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['floor']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.floor' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.floor" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['room']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.room' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.room" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['job']) || !hideEmptyFields">
      <mat-label>{{'dynamicContent.job' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.content.job" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="(hideEmptyFields && showFields['note']) || !hideEmptyFields" class="full-width">
      <mat-label>Text</mat-label>
      <textarea [(ngModel)]="translationEntries[lang].content.note" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10"></textarea>
    </mat-form-field>
  </mat-card>
</ng-container>
